module.exports = __webpack_public_path__ + "static/cynthias.b39b3cf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cynthias.jpg
// module id = 345
// module chunks = 35783957827783